import { render, staticRenderFns } from "./EmployeeVacations.vue?vue&type=template&id=0b604c64&"
import script from "./EmployeeVacations.vue?vue&type=script&lang=js&"
export * from "./EmployeeVacations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports